<template>
  <footer class="footer">
    <div class="grid grid--container">
      <nav class="footer__middle">
        <div class="footer__middle__section">
          <span class="footer__middle__title">Campsite.bio</span>
          <ul>
            <li>
              <a href="https://app.campsite.bio/login">Log in</a>
            </li>
            <li>
              <a href="https://app.campsite.bio/create-account">Sign up</a>
            </li>
            <li>
              <nuxt-link to="/pricing">Pricing</nuxt-link>
            </li>
            <li>
              <nuxt-link to="/media-kit">Media kit</nuxt-link>
            </li>
            <li>
              <nuxt-link to="/landing/advanced-analytics"
                >Advanced Analytics</nuxt-link
              >
            </li>
          </ul>
        </div>
        <div class="footer__middle__section">
          <span class="footer__middle__title">Resources</span>
          <ul>
            <li>
              <nuxt-link to="/contact-us">Contact us</nuxt-link>
            </li>
            <li>
              <nuxt-link to="/blog">Blog</nuxt-link>
            </li>
            <li>
              <a href="https://support.campsite.bio/en/">Support</a>
            </li>
            <li>
              <a
                href="https://support.campsite.bio/en/articles/6818213-getting-started-with-campsite-bio"
                >Getting Started</a
              >
            </li>
            <li>
              <a
                href="https://support.campsite.bio/en/articles/6848994-referral-program"
                >Referral Program</a
              >
            </li>
          </ul>
        </div>
        <div class="footer__middle__section">
          <span class="footer__middle__title">Use Cases</span>
          <ul>
            <li>
              <nuxt-link to="/use-cases/agencies">Agencies</nuxt-link>
            </li>
            <li>
              <nuxt-link to="/use-cases/creators"
                >Creators / Influencers</nuxt-link
              >
            </li>
            <li>
              <nuxt-link to="/use-cases/non-profits">Non-profits</nuxt-link>
            </li>
            <li>
              <nuxt-link to="/use-cases/organizations">Organizations</nuxt-link>
            </li>
            <li>
              <nuxt-link to="/use-cases/small-business"
                >Small Business</nuxt-link
              >
            </li>
            <li>
              <nuxt-link to="/use-cases/social-media-managers"
                >Social Media Managers</nuxt-link
              >
            </li>
          </ul>
        </div>
      </nav>

      <div class="footer__btm">
        <Logo />

        <nav
          class="footer__btm__nav footer__btm__nav--social"
          aria-label="Social"
        >
          <ul>
            <li>
              <a
                class="footer__nav-campsite"
                href="https://campsite.bio/camper"
                target="_blank"
              >
                <Logo class="footer-logo" only-mark size="24" />
                <span class="sr-only">Campsite.bio profile page</span>
              </a>
            </li>
            <li>
              <a
                class="footer__nav-insta"
                href="https://www.instagram.com/campsite.bio/"
                target="_blank"
                rel="noopener"
              >
                <InstagramIcon />
                <span class="sr-only">Instagram</span>
              </a>
            </li>
            <li>
              <a
                class="footer__nav-facebook"
                href="https://www.facebook.com/campsite.bio/"
                target="_blank"
                rel="noopener"
              >
                <FacebookLetterFIcon />
                <span class="sr-only">Facebook</span>
              </a>
            </li>
            <li>
              <a
                class="footer__nav-twitter"
                href="https://twitter.com/campsitebio"
                target="_blank"
                rel="noopener"
              >
                <TwitterIcon />
                <span class="sr-only">Twitter</span>
              </a>
            </li>
          </ul>
        </nav>

        <p class="footer__btm__love">
          Made with
          <HeartIcon />
          in Milwaukee 🇺🇸
        </p>

        <nav class="footer__btm__nav" aria-label="Privacy & Terms">
          <p class="footer__copyright">
            &copy; {{ new Date().getFullYear() }} Campsite.bio
          </p>

          <ul>
            <li>
              <nuxt-link to="/privacy">Privacy</nuxt-link>
            </li>
            <li>
              <nuxt-link to="/terms">Terms</nuxt-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </footer>
</template>

<script>
import {
  FacebookLetterFIcon,
  InstagramIcon,
  TwitterIcon,
  HeartIcon,
  Logo,
} from '@campsite-bio/component-lib';

export default {
  components: {
    Logo,
    FacebookLetterFIcon,
    InstagramIcon,
    TwitterIcon,
    HeartIcon,
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: #465049;
  color: white;
  padding-top: 2rem;
  padding-bottom: 2.5rem;

  @media (min-width: 544px) {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  a {
    display: inline-flex;
    color: inherit;
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }

  &__middle {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;

    &__section {
      flex-basis: 100%;

      @media (min-width: 544px) {
        flex-basis: calc(50% - 2rem);
      }

      @media (min-width: 768px) {
        flex-basis: calc(33.333% - 2rem);
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 0.5rem 0 0;

        li {
          margin-top: 0.25rem;
        }
      }
    }

    &__title {
      font-weight: 900;
    }
  }

  &__copyright {
    margin: 0 1.5rem 0 0;
  }

  &__btm {
    border-top: 1px solid rgba(255, 255, 255, 0.25);
    padding-top: 2rem;
    margin-top: 2rem;
    position: relative;

    &__love {
      font-size: 0.85rem;
      margin: 0.5rem 0 0;
    }

    &__nav,
    &__nav ul {
      align-items: center;
      display: flex;
    }

    &__nav {
      margin-top: 0.75rem;

      &--social {
        font-size: 1.75rem;
        margin: 0.75rem 0;

        @media (min-width: 768px) {
          position: absolute;
          right: 0;
          top: calc(50% + 1rem);
          transform: translateY(-50%);
          margin: 0;
        }

        a:hover,
        a:focus {
          transform: scale(1.1);
        }
      }

      ul {
        list-style: none;
        gap: 1.5rem;
        margin: 0;

        li {
          display: inline-flex;
        }
      }
    }
  }
}
</style>
